
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _1242qDmzd2nLzOMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/1242.vue?macro=true";
import { default as capacidade_45coletoresdAsQcSG4btMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/capacidade-coletores.vue?macro=true";
import { default as convocacao_45ativaY3Qx6dHyEoMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/convocacao-ativa.vue?macro=true";
import { default as estoque_45curva_45financeiraNJ1e1tKaQaMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/estoque-curva-financeira.vue?macro=true";
import { default as inventarioXu1T4Gm4wQMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/inventario.vue?macro=true";
import { default as produtividade_45remuneracao_45tvbi7nE7moTUMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/produtividade-remuneracao-tv.vue?macro=true";
import { default as produtividade_45remuneracaoAegpJSRMATMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/produtividade-remuneracao.vue?macro=true";
import { default as separacao_45coletorHVtB7V3xzHMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/separacao-coletor.vue?macro=true";
import { default as separacao_45volumes_45caixariayPjH07rFRJMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/separacao-volumes-caixaria.vue?macro=true";
import { default as separacaoMU9CXGez3xMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/separacao.vue?macro=true";
import { default as AcompanhamentoOperacoesMMMqVzawWCMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/AcompanhamentoOperacoes.vue?macro=true";
import { default as consolidada3MAthehU1pMeta } from "/opt/harpia/harpiawms-web/modules/PROC_AVERIGUACAO_CAIXA_UNIDADE/client/pages/averiguacao/consolidada.vue?macro=true";
import { default as unidadek8jF8o93DCMeta } from "/opt/harpia/harpiawms-web/modules/PROC_AVERIGUACAO_PICKING_UNIDADE/client/pages/averiguacao/unidade.vue?macro=true";
import { default as _326SzJOeBowQdMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/B/326.vue?macro=true";
import { default as _91modo_9327PvRYy3i1Meta } from "/opt/harpia/harpiawms-web/frontend/src/pages/B23/[modo].vue?macro=true";
import { default as b311_testexOhXMOtdFMMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/B311_teste/b311_teste.ts?macro=true";
import { default as B311olWOs1LJrdMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/B311_teste/B311.vue?macro=true";
import { default as B331qPZAHUvt0XMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/B331.vue?macro=true";
import { default as BasicowWbnA22feJMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/Basico.vue?macro=true";
import { default as vinculoPickingEtiqueta0awPo8K836Meta } from "/opt/harpia/harpiawms-web/modules/PROC_ASSOCIA_ENDERECO_PICKING_COLETOR/client/pages/cadastro/vinculoPickingEtiqueta.vue?macro=true";
import { default as vinculoPickingEtiquetaRuaPredioEu57Qzxjj6Meta } from "/opt/harpia/harpiawms-web/modules/PROC_ASSOCIA_ENDERECO_PICKING_COLETOR/client/pages/cadastro/vinculoPickingEtiquetaRuaPredio.vue?macro=true";
import { default as CADB_PADRAO_ETIQUETA_MERC6pN1N7i6kLMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/CADB_PADRAO_ETIQUETA_MERC.vue?macro=true";
import { default as caraCrachaCYftbofzquMeta } from "/opt/harpia/harpiawms-web/modules/PROC_CARA_CRACHA_CONF_COLETOR/client/pages/conferencia/caraCracha.vue?macro=true";
import { default as CONS_STATUS_SEPARACAO_MERCADORIASBL4BNksIhRMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/consulta/CONS_STATUS_SEPARACAO_MERCADORIAS.vue?macro=true";
import { default as enderecoVQnZ8pzx0FMeta } from "/opt/harpia/harpiawms-web/modules/PROC_CONSULTA_ENDERECO/client/pages/consulta/endereco.vue?macro=true";
import { default as UMApJPX6vjGPXMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/consulta/UMA.vue?macro=true";
import { default as _1150HorlYCXfPhMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/contaCorrente/1150.vue?macro=true";
import { default as _1151yUrkzgwdv7Meta } from "/opt/harpia/harpiawms-web/frontend/src/pages/contaCorrente/1151.vue?macro=true";
import { default as _1152B4ulDLODH3Meta } from "/opt/harpia/harpiawms-web/frontend/src/pages/contaCorrente/1152.vue?macro=true";
import { default as colagemCracha6rpHFlewYAMeta } from "/opt/harpia/harpiawms-web/modules/PROC_CONV_ATIVA_COLAGEM_CRACHA/client/pages/convocacaoAtiva/colagemCracha.vue?macro=true";
import { default as databaseJN5PHJP8tEMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/database.vue?macro=true";
import { default as _1150EBtbEZFbB2Meta } from "/opt/harpia/harpiawms-web/frontend/src/pages/gestaoAcessos/1150.vue?macro=true";
import { default as _1151Z9N5br2iTxMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/gestaoAcessos/1151.vue?macro=true";
import { default as _1152OUf1VQpxCaMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/gestaoAcessos/1152.vue?macro=true";
import { default as indextB75P0k5fBMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/index.vue?macro=true";
import { default as associarLote2iUt7M9YIhMeta } from "/opt/harpia/harpiawms-web/modules/PROC_INVENTARIO_COLETOR_ASSOCIAR_LOTE/client/pages/inventario/associarLote.vue?macro=true";
import { default as coletorC6bR6q7nrpMeta } from "/opt/harpia/harpiawms-web/modules/PROC_INVENTARIO_COLETOR/client/pages/inventario/coletor.vue?macro=true";
import { default as expressov1Vh3T0ZhlMeta } from "/opt/harpia/harpiawms-web/modules/PROC_INVENTARIO_EXPRESSO_COLETOR/client/pages/inventario/expresso.vue?macro=true";
import { default as divergenciasWELZ65CLNRMeta } from "/opt/harpia/harpiawms-web/modules/PROC_LIBERACAO_AVERIG_CX_UN/client/pages/liberacao/divergencias.vue?macro=true";
import { default as Login92vdQktu2tMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/Login.vue?macro=true";
import { default as _1230v9bC8lk4HGMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/logistica/1230.vue?macro=true";
import { default as _1241lj1DSuV21QMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/logistica/1241.vue?macro=true";
import { default as combos1230MfouskmFdUMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/logistica/combos1230.ts?macro=true";
import { default as cargas_45consolidadaszEydNdSSaRMeta } from "/opt/harpia/harpiawms-web/modules/PROC_MONITORAMENTO_CARGAS_CONSOLIDADAS/client/pages/monitoramento/cargas-consolidadas.vue?macro=true";
import { default as expressaPAfZS4bSGKMeta } from "/opt/harpia/harpiawms-web/modules/PROC_AVARIA_COLETOR/client/pages/naoConformidade/expressa.vue?macro=true";
import { default as devolverMercadoriaPickingxCSEneOi1XMeta } from "/opt/harpia/harpiawms-web/modules/PROC_DEVOLVER_MERCADORIA_AO_PICKING/client/pages/pce/devolverMercadoriaPicking.vue?macro=true";
import { default as PROC_AVERIGUACAO_AUDITORIA_SEPARACAO_COLETORXR6CQh4RKdMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_AVERIGUACAO_AUDITORIA_SEPARACAO_COLETOR/PROC_AVERIGUACAO_AUDITORIA_SEPARACAO_COLETOR.vue?macro=true";
import { default as trocaUsuario_46composable8AnRjqSDYOMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_AVERIGUACAO_PICKING_CX_COLETOR/composables/trocaUsuario.composable.ts?macro=true";
import { default as PROC_AVERIGUACAO_PICKING_CX_COLETOReeYaSwU5BHMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_AVERIGUACAO_PICKING_CX_COLETOR/PROC_AVERIGUACAO_PICKING_CX_COLETOR.vue?macro=true";
import { default as PROC_AVERIGUACAO_PICKING_CX_COLETOR8eZKVvRcF0Meta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_AVERIGUACAO_PICKING_CX_COLETOR.vue?macro=true";
import { default as PROC_CADASTRO_DADOS_CODIGOBARRAS_COLETOR8A53BkEX6yMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_CADASTRO_DADOS_CODIGOBARRAS_COLETOR/PROC_CADASTRO_DADOS_CODIGOBARRAS_COLETOR.vue?macro=true";
import { default as PROC_CADASTRO_DADOS_LOGISTICOS_COLETORptqzWEU2opMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_CADASTRO_DADOS_LOGISTICOS_COLETOR/PROC_CADASTRO_DADOS_LOGISTICOS_COLETOR.vue?macro=true";
import { default as PROC_CONS_MERC_COLETORmj6pyysJvLMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_CONS_MERC_COLETOR.vue?macro=true";
import { default as PROC_CONV_ATIVA_COL_AGENTESGfsHPrI0GCMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_CONV_ATIVA_COL_AGENTES.vue?macro=true";
import { default as PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR1tU19J1i6VMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.vue?macro=true";
import { default as PROC_EFETIVACAO_ABASTECIMENTOtPzayE61sbMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_EFETIVACAO_ABASTECIMENTO.vue?macro=true";
import { default as PROC_INFORMA_CODIGO_USU_SEPotgrIZDHP9Meta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_INFORMA_CODIGO_USU_SEP/PROC_INFORMA_CODIGO_USU_SEP.vue?macro=true";
import { default as PROC_PALETES_LOCALIZACAO_DOCALvz2JQ8VT7Meta } from "/opt/harpia/harpiawms-web/frontend/src/pages/PROC_PALETES_LOCALIZACAO_DOCA/PROC_PALETES_LOCALIZACAO_DOCA.vue?macro=true";
import { default as atribuicao_45nao_45conformidadeHFKfuB7O5sMeta } from "/opt/harpia/harpiawms-web/modules/PROC_CONTROLE_NAO_CONFORMIDADE/client/pages/processos/atribuicao-nao-conformidade.vue?macro=true";
import { default as acondicionamentoaiE5ODmaR6Meta } from "/opt/harpia/harpiawms-web/modules/PROC_ENDERECO_RESERVADO_ENTRADA/client/pages/recebimento/acondicionamento.vue?macro=true";
import { default as coletor1inEGg5ci4Meta } from "/opt/harpia/harpiawms-web/modules/PROC_SEPARACAO_PICKING_UNIDADE_COLETOR/client/pages/separacao/coletor.vue?macro=true";
import { default as SequentialkVJZhoOqObMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/Sequential.vue?macro=true";
import { default as testeS381KkDwA0Meta } from "/opt/harpia/harpiawms-web/frontend/src/pages/teste/teste.vue?macro=true";
import { default as testeAreatx79oewpnYMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/teste/testeArea.vue?macro=true";
import { default as testeWIjVYn6YniMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/teste.vue?macro=true";
import { default as visualizarComponente2hd7v8XfsrMeta } from "/opt/harpia/harpiawms-web/frontend/src/pages/visualizarComponente.vue?macro=true";
export default [
  {
    name: "1242",
    path: "/1242",
    meta: _1242qDmzd2nLzOMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/1242.vue")
  },
  {
    name: "acompanhamento-capacidade-coletores",
    path: "/acompanhamento/capacidade-coletores",
    meta: capacidade_45coletoresdAsQcSG4btMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/capacidade-coletores.vue")
  },
  {
    name: "acompanhamento-convocacao-ativa",
    path: "/acompanhamento/convocacao-ativa",
    meta: convocacao_45ativaY3Qx6dHyEoMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/convocacao-ativa.vue")
  },
  {
    name: "acompanhamento-estoque-curva-financeira",
    path: "/acompanhamento/estoque-curva-financeira",
    meta: estoque_45curva_45financeiraNJ1e1tKaQaMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/estoque-curva-financeira.vue")
  },
  {
    name: "acompanhamento-inventario",
    path: "/acompanhamento/inventario",
    meta: inventarioXu1T4Gm4wQMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/inventario.vue")
  },
  {
    name: "acompanhamento-produtividade-remuneracao-tv",
    path: "/acompanhamento/produtividade-remuneracao-tv",
    meta: produtividade_45remuneracao_45tvbi7nE7moTUMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/produtividade-remuneracao-tv.vue")
  },
  {
    name: "acompanhamento-produtividade-remuneracao",
    path: "/acompanhamento/produtividade-remuneracao",
    meta: produtividade_45remuneracaoAegpJSRMATMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/produtividade-remuneracao.vue")
  },
  {
    name: "acompanhamento-separacao-coletor",
    path: "/acompanhamento/separacao-coletor",
    meta: separacao_45coletorHVtB7V3xzHMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/separacao-coletor.vue")
  },
  {
    name: "acompanhamento-separacao-volumes-caixaria",
    path: "/acompanhamento/separacao-volumes-caixaria",
    meta: separacao_45volumes_45caixariayPjH07rFRJMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/separacao-volumes-caixaria.vue")
  },
  {
    name: "acompanhamento-separacao",
    path: "/acompanhamento/separacao",
    meta: separacaoMU9CXGez3xMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/acompanhamento/separacao.vue")
  },
  {
    name: "AcompanhamentoOperacoes",
    path: "/AcompanhamentoOperacoes",
    meta: AcompanhamentoOperacoesMMMqVzawWCMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/AcompanhamentoOperacoes.vue")
  },
  {
    name: "averiguacao-consolidada",
    path: "/averiguacao/consolidada",
    meta: consolidada3MAthehU1pMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_AVERIGUACAO_CAIXA_UNIDADE/client/pages/averiguacao/consolidada.vue")
  },
  {
    name: "averiguacao-unidade",
    path: "/averiguacao/unidade",
    meta: unidadek8jF8o93DCMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_AVERIGUACAO_PICKING_UNIDADE/client/pages/averiguacao/unidade.vue")
  },
  {
    name: "B-326",
    path: "/B/326",
    meta: _326SzJOeBowQdMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/B/326.vue")
  },
  {
    name: "B23-modo",
    path: "/B23/:modo()",
    meta: _91modo_9327PvRYy3i1Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/B23/[modo].vue")
  },
  {
    name: "B311_teste-b311_teste",
    path: "/B311_teste/b311_teste",
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/B311_teste/b311_teste.ts")
  },
  {
    name: "B311_teste-B311",
    path: "/B311_teste/B311",
    meta: B311olWOs1LJrdMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/B311_teste/B311.vue")
  },
  {
    name: "B331",
    path: "/B331",
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/B331.vue")
  },
  {
    name: "Basico",
    path: "/Basico",
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/Basico.vue")
  },
  {
    name: "cadastro-vinculoPickingEtiqueta",
    path: "/cadastro/vinculoPickingEtiqueta",
    meta: vinculoPickingEtiqueta0awPo8K836Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_ASSOCIA_ENDERECO_PICKING_COLETOR/client/pages/cadastro/vinculoPickingEtiqueta.vue")
  },
  {
    name: "cadastro-vinculoPickingEtiquetaRuaPredio",
    path: "/cadastro/vinculoPickingEtiquetaRuaPredio",
    meta: vinculoPickingEtiquetaRuaPredioEu57Qzxjj6Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_ASSOCIA_ENDERECO_PICKING_COLETOR/client/pages/cadastro/vinculoPickingEtiquetaRuaPredio.vue")
  },
  {
    name: "CADB_PADRAO_ETIQUETA_MERC",
    path: "/CADB_PADRAO_ETIQUETA_MERC",
    meta: CADB_PADRAO_ETIQUETA_MERC6pN1N7i6kLMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/CADB_PADRAO_ETIQUETA_MERC.vue")
  },
  {
    name: "conferencia-caraCracha",
    path: "/conferencia/caraCracha",
    meta: caraCrachaCYftbofzquMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_CARA_CRACHA_CONF_COLETOR/client/pages/conferencia/caraCracha.vue")
  },
  {
    name: "consulta-CONS_STATUS_SEPARACAO_MERCADORIAS",
    path: "/consulta/CONS_STATUS_SEPARACAO_MERCADORIAS",
    meta: CONS_STATUS_SEPARACAO_MERCADORIASBL4BNksIhRMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/consulta/CONS_STATUS_SEPARACAO_MERCADORIAS.vue")
  },
  {
    name: "consulta-endereco",
    path: "/consulta/endereco",
    meta: enderecoVQnZ8pzx0FMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_CONSULTA_ENDERECO/client/pages/consulta/endereco.vue")
  },
  {
    name: "consulta-UMA",
    path: "/consulta/UMA",
    meta: UMApJPX6vjGPXMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/consulta/UMA.vue")
  },
  {
    name: "contaCorrente-1150",
    path: "/contaCorrente/1150",
    meta: _1150HorlYCXfPhMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/contaCorrente/1150.vue")
  },
  {
    name: "contaCorrente-1151",
    path: "/contaCorrente/1151",
    meta: _1151yUrkzgwdv7Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/contaCorrente/1151.vue")
  },
  {
    name: "contaCorrente-1152",
    path: "/contaCorrente/1152",
    meta: _1152B4ulDLODH3Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/contaCorrente/1152.vue")
  },
  {
    name: "convocacaoAtiva-colagemCracha",
    path: "/convocacaoAtiva/colagemCracha",
    meta: colagemCracha6rpHFlewYAMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_CONV_ATIVA_COLAGEM_CRACHA/client/pages/convocacaoAtiva/colagemCracha.vue")
  },
  {
    name: "database",
    path: "/database",
    meta: databaseJN5PHJP8tEMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/database.vue")
  },
  {
    name: "gestaoAcessos-1150",
    path: "/gestaoAcessos/1150",
    meta: _1150EBtbEZFbB2Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/gestaoAcessos/1150.vue")
  },
  {
    name: "gestaoAcessos-1151",
    path: "/gestaoAcessos/1151",
    meta: _1151Z9N5br2iTxMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/gestaoAcessos/1151.vue")
  },
  {
    name: "gestaoAcessos-1152",
    path: "/gestaoAcessos/1152",
    meta: _1152OUf1VQpxCaMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/gestaoAcessos/1152.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indextB75P0k5fBMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/index.vue")
  },
  {
    name: "inventario-associarLote",
    path: "/inventario/associarLote",
    meta: associarLote2iUt7M9YIhMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_INVENTARIO_COLETOR_ASSOCIAR_LOTE/client/pages/inventario/associarLote.vue")
  },
  {
    name: "inventario-coletor",
    path: "/inventario/coletor",
    meta: coletorC6bR6q7nrpMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_INVENTARIO_COLETOR/client/pages/inventario/coletor.vue")
  },
  {
    name: "inventario-expresso",
    path: "/inventario/expresso",
    meta: expressov1Vh3T0ZhlMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_INVENTARIO_EXPRESSO_COLETOR/client/pages/inventario/expresso.vue")
  },
  {
    name: "liberacao-divergencias",
    path: "/liberacao/divergencias",
    meta: divergenciasWELZ65CLNRMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_LIBERACAO_AVERIG_CX_UN/client/pages/liberacao/divergencias.vue")
  },
  {
    name: "Login",
    path: "/Login",
    meta: Login92vdQktu2tMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/Login.vue")
  },
  {
    name: "logistica-1230",
    path: "/logistica/1230",
    meta: _1230v9bC8lk4HGMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/logistica/1230.vue")
  },
  {
    name: "logistica-1241",
    path: "/logistica/1241",
    meta: _1241lj1DSuV21QMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/logistica/1241.vue")
  },
  {
    name: "logistica-combos1230",
    path: "/logistica/combos1230",
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/logistica/combos1230.ts")
  },
  {
    name: "monitoramento-cargas-consolidadas",
    path: "/monitoramento/cargas-consolidadas",
    meta: cargas_45consolidadaszEydNdSSaRMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_MONITORAMENTO_CARGAS_CONSOLIDADAS/client/pages/monitoramento/cargas-consolidadas.vue")
  },
  {
    name: "naoConformidade-expressa",
    path: "/naoConformidade/expressa",
    meta: expressaPAfZS4bSGKMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_AVARIA_COLETOR/client/pages/naoConformidade/expressa.vue")
  },
  {
    name: "pce-devolverMercadoriaPicking",
    path: "/pce/devolverMercadoriaPicking",
    meta: devolverMercadoriaPickingxCSEneOi1XMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_DEVOLVER_MERCADORIA_AO_PICKING/client/pages/pce/devolverMercadoriaPicking.vue")
  },
  {
    name: "PROC_AVERIGUACAO_AUDITORIA_SEPARACAO_COLETOR",
    path: "/PROC_AVERIGUACAO_AUDITORIA_SEPARACAO_COLETOR",
    meta: PROC_AVERIGUACAO_AUDITORIA_SEPARACAO_COLETORXR6CQh4RKdMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_AVERIGUACAO_AUDITORIA_SEPARACAO_COLETOR/PROC_AVERIGUACAO_AUDITORIA_SEPARACAO_COLETOR.vue")
  },
  {
    name: "PROC_AVERIGUACAO_PICKING_CX_COLETOR",
    path: "/PROC_AVERIGUACAO_PICKING_CX_COLETOR",
    meta: PROC_AVERIGUACAO_PICKING_CX_COLETOR8eZKVvRcF0Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_AVERIGUACAO_PICKING_CX_COLETOR.vue"),
    children: [
  {
    name: "PROC_AVERIGUACAO_PICKING_CX_COLETOR-composables-trocaUsuario.composable",
    path: "composables/trocaUsuario.composable",
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_AVERIGUACAO_PICKING_CX_COLETOR/composables/trocaUsuario.composable.ts")
  },
  {
    name: "PROC_AVERIGUACAO_PICKING_CX_COLETOR-PROC_AVERIGUACAO_PICKING_CX_COLETOR",
    path: "PROC_AVERIGUACAO_PICKING_CX_COLETOR",
    meta: PROC_AVERIGUACAO_PICKING_CX_COLETOReeYaSwU5BHMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_AVERIGUACAO_PICKING_CX_COLETOR/PROC_AVERIGUACAO_PICKING_CX_COLETOR.vue")
  }
]
  },
  {
    name: "PROC_CADASTRO_DADOS_CODIGOBARRAS_COLETOR",
    path: "/PROC_CADASTRO_DADOS_CODIGOBARRAS_COLETOR",
    meta: PROC_CADASTRO_DADOS_CODIGOBARRAS_COLETOR8A53BkEX6yMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_CADASTRO_DADOS_CODIGOBARRAS_COLETOR/PROC_CADASTRO_DADOS_CODIGOBARRAS_COLETOR.vue")
  },
  {
    name: "PROC_CADASTRO_DADOS_LOGISTICOS_COLETOR",
    path: "/PROC_CADASTRO_DADOS_LOGISTICOS_COLETOR",
    meta: PROC_CADASTRO_DADOS_LOGISTICOS_COLETORptqzWEU2opMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_CADASTRO_DADOS_LOGISTICOS_COLETOR/PROC_CADASTRO_DADOS_LOGISTICOS_COLETOR.vue")
  },
  {
    name: "PROC_CONS_MERC_COLETOR",
    path: "/PROC_CONS_MERC_COLETOR",
    meta: PROC_CONS_MERC_COLETORmj6pyysJvLMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_CONS_MERC_COLETOR.vue")
  },
  {
    name: "PROC_CONV_ATIVA_COL_AGENTES",
    path: "/PROC_CONV_ATIVA_COL_AGENTES",
    meta: PROC_CONV_ATIVA_COL_AGENTESGfsHPrI0GCMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_CONV_ATIVA_COL_AGENTES.vue")
  },
  {
    name: "PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR",
    path: "/PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR",
    meta: PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR1tU19J1i6VMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.vue")
  },
  {
    name: "PROC_EFETIVACAO_ABASTECIMENTO",
    path: "/PROC_EFETIVACAO_ABASTECIMENTO",
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_EFETIVACAO_ABASTECIMENTO.vue")
  },
  {
    name: "PROC_INFORMA_CODIGO_USU_SEP",
    path: "/PROC_INFORMA_CODIGO_USU_SEP",
    meta: PROC_INFORMA_CODIGO_USU_SEPotgrIZDHP9Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_INFORMA_CODIGO_USU_SEP/PROC_INFORMA_CODIGO_USU_SEP.vue")
  },
  {
    name: "PROC_PALETES_LOCALIZACAO_DOCA",
    path: "/PROC_PALETES_LOCALIZACAO_DOCA",
    meta: PROC_PALETES_LOCALIZACAO_DOCALvz2JQ8VT7Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/PROC_PALETES_LOCALIZACAO_DOCA/PROC_PALETES_LOCALIZACAO_DOCA.vue")
  },
  {
    name: "processos-atribuicao-nao-conformidade",
    path: "/processos/atribuicao-nao-conformidade",
    meta: atribuicao_45nao_45conformidadeHFKfuB7O5sMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_CONTROLE_NAO_CONFORMIDADE/client/pages/processos/atribuicao-nao-conformidade.vue")
  },
  {
    name: "recebimento-acondicionamento",
    path: "/recebimento/acondicionamento",
    meta: acondicionamentoaiE5ODmaR6Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_ENDERECO_RESERVADO_ENTRADA/client/pages/recebimento/acondicionamento.vue")
  },
  {
    name: "separacao-coletor",
    path: "/separacao/coletor",
    meta: coletor1inEGg5ci4Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/modules/PROC_SEPARACAO_PICKING_UNIDADE_COLETOR/client/pages/separacao/coletor.vue")
  },
  {
    name: "Sequential",
    path: "/Sequential",
    meta: SequentialkVJZhoOqObMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/Sequential.vue")
  },
  {
    name: "teste",
    path: "/teste",
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/teste.vue"),
    children: [
  {
    name: "teste-teste",
    path: "teste",
    meta: testeS381KkDwA0Meta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/teste/teste.vue")
  },
  {
    name: "teste-testeArea",
    path: "testeArea",
    meta: testeAreatx79oewpnYMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/teste/testeArea.vue")
  }
]
  },
  {
    name: "visualizarComponente",
    path: "/visualizarComponente",
    meta: visualizarComponente2hd7v8XfsrMeta || {},
    component: () => import("/opt/harpia/harpiawms-web/frontend/src/pages/visualizarComponente.vue")
  }
]